import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { interestClassBookSettingConfig } from './InterestClassBookSetting.name';

/** 利息区分(帳簿設定)のENUM */
enum InterestClassBookSetting {
  /** 利子抜き */
  interestExcluded = '1',
  /** 利子込み */
  interestIncluded = '2',
}

const interestClassBookSettingMap = new Map([
  ['1', InterestClassBookSetting.interestExcluded],
  ['2', InterestClassBookSetting.interestIncluded],
]);

const rawValueToInterestClassBookSetting = rawValueToEnumWithDefault(interestClassBookSettingMap, '');

const interestClassBookSettingToDisplay = enumToNameWithDefault(
  InterestClassBookSetting,
  interestClassBookSettingConfig,
);

const interestClassBookSettingToDisplayWithPrefix = enumToNameWithDefault(
  InterestClassBookSetting,
  interestClassBookSettingConfig,
  true,
);

export {
  InterestClassBookSetting,
  interestClassBookSettingToDisplay,
  interestClassBookSettingToDisplayWithPrefix,
  rawValueToInterestClassBookSetting,
};
